import React from 'react';
import { css, Global as EmotionGlobal } from '@emotion/react';
const Global = () => {
  return (
    <EmotionGlobal
      styles={css`
        * {
          box-sizing: border-box;
        }

        @font-face {
          font-family: 'CircularStd';
          font-weight: 600;
          src: url(https://s3.amazonaws.com/cdn.hotglue.xyz/fonts/CircularStd-Bold/CircularStd-Bold.eot);
          src: url(https://s3.amazonaws.com/cdn.hotglue.xyz/fonts/CircularStd-Bold/CircularStd-Bold.eot?#iefix)
              format('embedded-opentype'),
            url(https://s3.amazonaws.com/cdn.hotglue.xyz/fonts/CircularStd-Bold/CircularStd-Bold.woff) format('woff'),
            url(https://s3.amazonaws.com/cdn.hotglue.xyz/fonts/CircularStd-Bold/CircularStd-Bold.ttf) format('truetype');
        }

        @font-face {
          font-family: 'CircularStd';
          font-weight: 400;
          src: url(https://s3.amazonaws.com/cdn.hotglue.xyz/fonts/CircularStd-Medium/CircularStd-Medium.eot);
          src: url(https://s3.amazonaws.com/cdn.hotglue.xyz/fonts/CircularStd-Medium/CircularStd-Medium.eot?#iefix)
              format('embedded-opentype'),
            url(https://s3.amazonaws.com/cdn.hotglue.xyz/fonts/CircularStd-Medium/CircularStd-Medium.woff)
              format('woff'),
            url(https://s3.amazonaws.com/cdn.hotglue.xyz/fonts/CircularStd-Medium/CircularStd-Medium.ttf)
              format('truetype');
        }

        @font-face {
          font-family: 'CircularStd';
          font-weight: 300;
          src: url(https://s3.amazonaws.com/cdn.hotglue.xyz/fonts/CircularStd-Book/CircularStd-Book.eot);
          src: url(https://s3.amazonaws.com/cdn.hotglue.xyz/fonts/CircularStd-Book/CircularStd-Book.eot?#iefix)
              format('embedded-opentype'),
            url(https://s3.amazonaws.com/cdn.hotglue.xyz/fonts/CircularStd-Book/CircularStd-Book.woff) format('woff'),
            url(https://s3.amazonaws.com/cdn.hotglue.xyz/fonts/CircularStd-Book/CircularStd-Book.ttf) format('truetype');
        }
      `}
    />
  );
};
export default Global;
